module.exports = __webpack_public_path__ + "front/img/main-img-2.60a4a6ce.png";